import {tabs as tabNumbers, supportedPics, extentionIcons} from '../consts';
import {PriorityIcon} from '@priority-software/priority-style-react';

export function getMenuProps(props) {
    let tabType;
    let dataItems;
    const {tabIndex, tabs, activeScreens, recentItems, lastUpdates} = props;

    switch (tabIndex) {
        case tabNumbers.ACTIVE_SCREENS:
            tabType = 'active-screens';
            dataItems = activeScreens;
            break;
        case tabNumbers.LAST_UPDATES:
            tabType = 'last-updates';
            dataItems = lastUpdates;
            break;
        case tabNumbers.RECENT_ITEMS:
            tabType = 'recent-items';
            dataItems = recentItems;
            break;
    }

    const menuTitle = tabs[tabIndex].title;

    return {
        tabType,
        dataItems,
        menuTitle
    };
}

export function getFileExtention(fileName: string) {
    const splittedFileName = fileName && fileName.split('.');
    if (splittedFileName && splittedFileName.length > 1) {
        return splittedFileName[splittedFileName.length - 1];
    } else {
        return null;
    }
}

export function isAPic(fileExtention: string) {
    if (fileExtention) {
        return supportedPics.includes(fileExtention.toLowerCase());
    } else {
        return false;
    }
}

export function getPreviewIcon(fileExtention: string) {
    return extentionIcons[fileExtention] ? extentionIcons[fileExtention] : PriorityIcon.emptyFile;
}
